import { render, staticRenderFns } from "./ModalSendDocumentContract.vue?vue&type=template&id=63684e4d&"
import script from "./ModalSendDocumentContract.vue?vue&type=script&lang=js&"
export * from "./ModalSendDocumentContract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports